import { C, STROKE, Figure, Label, Leader, arrow } from './figureStyle';

const ID = 'fig-termostat';

// Returfjeder mellem stiftens krave og pakdåsen
const SPRING = Array.from({ length: 9 }, (_, i) => `${i % 2 === 0 ? 168 : 192},${166 + i * 3}`).join(' ');

export default function TermostatSnitFigure() {
  return (
    <Figure
      id={ID}
      height={356}
      title="Snit gennem termostathoved og radiatorventil: følerelementet i hovedet trykker stiften ned, stiften trykker ventilkeglen mod ventilsædet, og returfjederen i ventilen skubber stiften op igen."
      caption="Termostatens mekaniske opbygning: når rumluften opvarmer bælgen, udvider den sig og presser via stiften ventilkeglen mod sædet for at dæmpe vandtilførslen."
    >
      {/* Termostathoved med følerelement */}
      <rect x="100" y="30" width="160" height="110" rx="14" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="124" y="46" width="112" height="72" rx="12" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="148" y="140" width="64" height="12" rx="3" fill={C.line} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Ventil: pakdåse, hus og sæde */}
      <rect x="160" y="190" width="40" height="50" rx="3" fill={C.line} stroke={C.dark} strokeWidth={STROKE.outline} />
      <rect x="80" y="240" width="220" height="100" rx="10" fill={C.page} stroke={C.dark} strokeWidth={STROKE.outline} />
      <line x1="80" y1="290" x2="160" y2="290" stroke={C.dark} strokeWidth={STROKE.outline} />
      <line x1="200" y1="290" x2="300" y2="290" stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Stift fra følerelementet ned til ventilkeglen, med krave og returfjeder */}
      <rect x="177" y="118" width="6" height="144" rx="2" fill={C.dark} />
      <rect x="166" y="158" width="28" height="6" rx="2" fill={C.dark} />
      <polyline points={SPRING} fill="none" stroke={C.rust} strokeWidth={STROKE.secondary} />
      <rect x="156" y="262" width="48" height="12" rx="4" fill={C.light} stroke={C.dark} strokeWidth={STROKE.outline} />

      {/* Vandet: ind under sædet, ud over sædet mod radiatoren */}
      <line x1="10" y1="318" x2="76" y2="318" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />
      <path d="M92,318 H166 Q178,318 178,306 V296" fill="none" stroke={C.rust} strokeWidth={STROKE.secondary} strokeDasharray="4 4" markerEnd={arrow(ID, 'hot')} />
      <line x1="302" y1="256" x2="352" y2="256" stroke={C.rust} strokeWidth={STROKE.outline} markerEnd={arrow(ID, 'hot')} />

      {/* Labels */}
      <Label x={180} y={20} anchor="middle" lines={['Termostathoved']} />
      <Label x={180} y={87} anchor="middle" lines={['Følerelement']} />
      <Label x={232} y={160} lines={['Stift']} />
      <Leader points="228,155 187,155" />
      <Label x={232} y={184} lines={['Returfjeder']} />
      <Leader points="228,180 196,180" />
      <Label x={210} y={272} lines={['Ventilkegle']} />
      <Label x={210} y={312} lines={['Ventilsæde']} />
      <Leader points="206,306 201,292" />
    </Figure>
  );
}
